// @flow
type PauseReason = 'beforeunload' | 'blur' | 'pagehide' | 'visibilitychange'; // more details here: https://phabricator.pinadmin.com/D435041

class PageVisibility {
  onResumeListeners = [];
  onPauseListeners = [];
  inExp = false;

  // function to help add experiments to PageVisibility, needs to be enabled elsewhere and set to true or false
  setExperiment(inExperiment: boolean = false) {
    this.inExp = inExperiment;
  }

  onSessionResume(listener: () => void) {
    this.onResumeListeners.push(listener);
    return this;
  }

  onSessionPause(listener: (reason: PauseReason) => void) {
    this.onPauseListeners.push(listener);
    return this;
  }
}

const instance = new PageVisibility();

type VisibilityHandlerOption = {| isHidden: false |} | {| isHidden: true, reason: PauseReason |};

const visibilityHandler = (visibilityOption: VisibilityHandlerOption) => {
  if (visibilityOption.isHidden) {
    const { reason } = visibilityOption;
    // NOTE: this calls PAUSE listeners
    instance.onPauseListeners.forEach((listener) => listener(reason));
  } else {
    // NOTE: this calls RESUME listeners
    instance.onResumeListeners.forEach((listener) => listener());
  }
};

if (!__SERVER__) {
  setTimeout(() => {
    // Flush events before the window is unloaded.
    window.addEventListener('beforeunload', () =>
      visibilityHandler({ isHidden: true, reason: 'beforeunload' }),
    );
    window.addEventListener('focus', () => visibilityHandler({ isHidden: false }));
    window.addEventListener('blur', () => visibilityHandler({ isHidden: true, reason: 'blur' }));

    // because ios safari doesn't support beforeunload (╯°□°）╯︵ ┻━┻
    window.addEventListener('pageshow', () => visibilityHandler({ isHidden: false }));
    window.addEventListener('pagehide', () =>
      visibilityHandler({ isHidden: true, reason: 'pagehide' }),
    );
    if (typeof document.hidden !== 'undefined') {
      // the document.hidden boolean is a direct map to unload for visibilityHandler purposes
      document.addEventListener(
        'visibilitychange',
        () =>
          visibilityHandler(
            document.hidden ? { isHidden: true, reason: 'visibilitychange' } : { isHidden: false },
          ),
        false,
      );
      // $FlowIssue: flow missing annotation for webkitHidden on document
    } else if (typeof document.webkitHidden !== 'undefined') {
      document.addEventListener(
        'webkitvisibilitychange',
        // the webkitHidden boolean is a direct map to unload for visibilityHandler purposes
        () =>
          visibilityHandler(
            // $FlowIssue: flow missing annotation for webkitHidden on document
            document.webkitHidden
              ? { isHidden: true, reason: 'visibilitychange' }
              : { isHidden: false },
          ),
        false,
      );
    }
  }, 0);
}

export default instance;
